import {createAction} from '@reduxjs/toolkit'

export const seatingMapButtonClick = createAction<string>('SEATING_MAP_BUTTON_CLICK')
